import * as TYPES from './mutations-types'

export default {
  storePhoto ({commit}, payload) {
    const mutationsType = TYPES.STORE_PHOTO
    commit(mutationsType, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/module/photo/actions.js